import React from "react";

interface UploadIconProps {
  className?: string;
}

const UploadIcon = ({ className }: UploadIconProps) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11 2.75V14.2083M11 2.75L6.41666 7.33333M11 2.75L15.5833 7.33333M2.75 14.2083V17.875C2.75 18.3612 2.94315 18.8275 3.28697 19.1714C3.63079 19.5152 4.0971 19.7083 4.58333 19.7083H17.4167C17.9029 19.7083 18.3692 19.5152 18.713 19.1714C19.0568 18.8275 19.25 18.3612 19.25 17.875V14.2083"
      stroke="var(--gray-800)"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UploadIcon;
